import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { renderRoutes, matchRoutes } from "react-router-config";
import { Switch } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Notifications } from "../modules/notification";
import { HELLO_BAR_ON } from "./HelloBar";

const Root = ({ route, location, showHelloBar }) => {
  // Each new page starts at the top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Routes marked bare (the 404) draw the whole screen themselves
  const bare = matchRoutes(route.routes, location.pathname).some((match) => match.route.bare);
  if (bare) {
    return (
      <div>
        <Switch>{renderRoutes(route.routes)}</Switch>
      </div>
    );
  }
  return (
    // The Kirki bar makes the fixed header taller; pages leave room through --header-h
    <div className={showHelloBar ? "has-hello-bar" : undefined}>
      <Navbar
        showHelloBar={showHelloBar}
        location={location}
        // className={location.pathname === "/" ? "home__navbar" : ""}
      />
      <div className="content-area" id="content-area">
        <Switch>{renderRoutes(route.routes)}</Switch>
        <Footer />
      </div>
      <Notifications />
    </div>
  );
};
Root.propTypes = {
  route: PropTypes.object,
  location: PropTypes.object,
  showHelloBar: PropTypes.bool,
};

export default connect((store) => ({ showHelloBar: HELLO_BAR_ON && !store.globalData.bannerDismissed }))(Root);
